import { Provider } from '@/types/provider'

export const providers: Provider[] = [
  {
    id: 'softswiss',
    name: 'Softswiss',
    thumbnail: {
      url: 'https://imagedelivery.net/9WutbSXJqeY8Kc44mJMbvA/softswiss.webp',
    },
    path: '/providers/softswiss',
    categories: [
      'slots',
      'liveCasino',
      'gameShows',
      'tableGames',
      'blackjack',
      'roulette',
      'newReleases',
    ],
    gameCount: 0,
  },
  {
    id: 'pragmaticexternal',
    name: 'Pragmatic External',
    thumbnail: {
      url: 'https://imagedelivery.net/9WutbSXJqeY8Kc44mJMbvA/pragmatic.webp',
    },
    path: '/providers/pragmaticexternal',
    categories: [
      'slots',
      'liveCasino',
      'gameShows',
      'tableGames',
      'blackjack',
      'roulette',
      'newReleases',
    ],
    gameCount: 0,
  },
  {
    id: 'thunderkick',
    name: 'Thunderkick',
    thumbnail: {
      url: 'https://imagedelivery.net/9WutbSXJqeY8Kc44mJMbvA/thunderkick.webp',
    },
    path: '/providers/thunderkick',
    categories: [
      'slots',
      'liveCasino',
      'gameShows',
      'tableGames',
      'blackjack',
      'roulette',
      'newReleases',
    ],
    gameCount: 0,
  },
  {
    id: 'mascot',
    name: 'Mascot',
    thumbnail: {
      url: 'https://imagedelivery.net/9WutbSXJqeY8Kc44mJMbvA/mascot.webp',
    },
    path: '/providers/mascot',
    categories: [
      'slots',
      'liveCasino',
      'gameShows',
      'tableGames',
      'blackjack',
      'roulette',
      'newReleases',
    ],
    gameCount: 0,
  },
  {
    id: 'avatarux',
    name: 'Avatarux',
    thumbnail: {
      url: 'https://imagedelivery.net/9WutbSXJqeY8Kc44mJMbvA/avatarux.webp',
    },
    path: '/providers/avatarux',
    categories: [
      'slots',
      'liveCasino',
      'gameShows',
      'tableGames',
      'blackjack',
      'roulette',
      'newReleases',
    ],
    gameCount: 0,
  },
  {
    id: 'playtech',
    name: 'Playtech',
    thumbnail: {
      url: 'https://imagedelivery.net/9WutbSXJqeY8Kc44mJMbvA/playtech.webp',
    },
    path: '/providers/playtech',
    categories: [
      'slots',
      'liveCasino',
      'gameShows',
      'tableGames',
      'blackjack',
      'roulette',
      'newReleases',
    ],
    gameCount: 0,
  },
  {
    id: 'fantasma',
    name: 'Fantasma',
    thumbnail: {
      url: 'https://imagedelivery.net/9WutbSXJqeY8Kc44mJMbvA/fantasma.webp',
    },
    path: '/providers/fantasma',
    categories: [
      'slots',
      'liveCasino',
      'gameShows',
      'tableGames',
      'blackjack',
      'roulette',
      'newReleases',
    ],
    gameCount: 0,
  },
  {
    id: 'slotmill',
    name: 'Slotmill',
    thumbnail: {
      url: 'https://imagedelivery.net/9WutbSXJqeY8Kc44mJMbvA/slotmill.webp',
    },
    path: '/providers/slotmill',
    categories: [
      'slots',
      'liveCasino',
      'gameShows',
      'tableGames',
      'blackjack',
      'roulette',
      'newReleases',
    ],
    gameCount: 0,
  },
  {
    id: 'nolimit',
    name: 'Nolimit',
    thumbnail: {
      url: 'https://imagedelivery.net/9WutbSXJqeY8Kc44mJMbvA/nolimit.webp',
    },
    path: '/providers/nolimit',
    categories: [
      'slots',
      'liveCasino',
      'gameShows',
      'tableGames',
      'blackjack',
      'roulette',
      'newReleases',
    ],
    gameCount: 0,
  },
  {
    id: 'hacksaw',
    name: 'Hacksaw',
    thumbnail: {
      url: 'https://imagedelivery.net/9WutbSXJqeY8Kc44mJMbvA/hacksaw.webp',
    },
    path: '/providers/hacksaw',
    categories: [
      'slots',
      'liveCasino',
      'gameShows',
      'tableGames',
      'blackjack',
      'roulette',
      'newReleases',
    ],
    gameCount: 0,
  },
  {
    id: 'habanero',
    name: 'Habanero',
    thumbnail: {
      url: 'https://imagedelivery.net/9WutbSXJqeY8Kc44mJMbvA/habanero.webp',
    },
    path: '/providers/habanero',
    categories: [
      'slots',
      'liveCasino',
      'gameShows',
      'tableGames',
      'blackjack',
      'roulette',
      'newReleases',
    ],
    gameCount: 0,
  },
]

const providersById = providers.reduce<Record<string, Provider>>(
  (result, provider) => {
    result[provider.id] = provider
    return result
  },
  {}
)

const providersByCategory = providers.reduce<Record<string, Provider[]>>(
  (result, provider) => {
    provider.categories.forEach((category) => {
      if (!result[category]) {
        result[category] = []
      }

      result[category].push(provider)
    })

    return result
  },
  {}
)

export const getProviderById = (id: string) => {
  return providersById[id]
}

export const getProvidersByCategory = (category?: string) => {
  if (!category) {
    return providers
  }

  return providersByCategory[category]
}
